import React from "react";

export default function Bottom() {
  return <div className="w-full  bg-neutral-400"></div>;
}
